import React from 'react';
import { UploadDTO } from '@api/upload/dto/UploadDTO';
import SendAndCancelOption from './SendAndCancelOption';
import AcceptAndRejectOption from './AcceptAndRejectOption';
import DownloadFileSetOption from './DownloadFileSetOption';

type Props = {
  uploadDTO: UploadDTO;
  triggerTableRefresh: (uploadsTableRefresh: boolean) => void;
};

function UploadOptions({ uploadDTO, triggerTableRefresh }: Props) {
  return (
    <>
      <SendAndCancelOption uploadDTO={uploadDTO} />
      <AcceptAndRejectOption uploadDTO={uploadDTO} triggerTableRefresh={triggerTableRefresh} />
      <DownloadFileSetOption uploadDTO={uploadDTO} />
    </>
  );
}

export default UploadOptions;
